import fr from "@/config/i18/fr";
import { formatDate } from "@/lib/utils";

export const translate = (key: string, lang: string = "en") => {
  if (lang === "en") return key;
  if (fr.hasOwnProperty(key)) return fr[key];
  else return key;
};

export function useTranslate() {
  // The hooks can fetch language from the backend.
  const lang =
    typeof window !== "undefined"
      ? localStorage.getItem("locale") || "en"
      : "en";

  return {
    t: (key: string) => {
      return translate(key, lang);
    },
    formatDate: (
      date: string | Date | null | undefined,
      formatStr: string = "d MMMM yyyy"
    ) => {
      return formatDate(date, formatStr, translate("en", lang));
    },
    translateOptions: (options: { label: string; value: any }[]) => {
      return options.map((item) => ({
        label: translate(item.label, lang),
        value: item.value,
      }));
    },
  };
}
